/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendCustomerProfitEmailCommand } from '../../models/send-customer-profit-email-command';
import { Success } from '../../models/success';

export interface SendCustomerProfitEmailAsync$Params {
      body?: SendCustomerProfitEmailCommand
}

export function sendCustomerProfitEmailAsync(http: HttpClient, rootUrl: string, params?: SendCustomerProfitEmailAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<Success>> {
  const rb = new RequestBuilder(rootUrl, sendCustomerProfitEmailAsync.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Success>;
    })
  );
}

sendCustomerProfitEmailAsync.PATH = '/api/report/customer/profits';
